// web/src/components/SoundToggle.tsx
import { useState, useEffect } from 'react';

export const SoundContext = {
  isMuted: false,
  setMuted: (muted: boolean) => {},
};

// Initialize from localStorage
const getStoredSoundState = (): boolean => {
  const stored = localStorage.getItem('goldrush_sound_muted');
  return stored === 'true';
};

export function useSound() {
  const [isMuted, setIsMuted] = useState(getStoredSoundState);

  useEffect(() => {
    localStorage.setItem('goldrush_sound_muted', String(isMuted));
    SoundContext.isMuted = isMuted;
    SoundContext.setMuted = setIsMuted;
  }, [isMuted]);

  const toggleSound = () => {
    setIsMuted(!isMuted);
  };

  return { isMuted, toggleSound };
}

export function shouldPlaySound(): boolean {
  return !SoundContext.isMuted;
}

export default function SoundToggle() {
  const { isMuted, toggleSound } = useSound();

  return (
    <button
      onClick={toggleSound}
      className="rounded-full p-3 transition-all hover:scale-110 active:scale-95 shadow-lg"
      style={{
        background: '#fffaeb',
        border: '2px solid #8b6542',
        color: '#3e2615',
      }}
      aria-label={isMuted ? 'Unmute sound' : 'Mute sound'}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Speaker icon */}
        <path
          d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
          fill="currentColor"
        />
        {/* Line through when muted */}
        {isMuted && (
          <line
            x1="2"
            y1="22"
            x2="22"
            y2="2"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
        )}
      </svg>
    </button>
  );
}

